module.exports = __webpack_public_path__ + "img/ico-like01.7fd97909.svg";